import {Badge, Box, Button, createStyles, Text} from '@mantine/core';
import React from 'react';

import {ACTION_CATEGORY} from 'analytics/AnalyticsTypes';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import preferences from 'Preferences';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../SidepanelActions';
import HomepageBanner from './HomepageBanner';
import {HomepagePreferences} from './HomepageConstants';
import {trackHomepageEvent} from './HomepageUtils';

const useStyles = createStyles((theme) => ({
  badge: {
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.yellow[4],
    color: theme.black,
    padding: theme.spacing.xs,
    flexShrink: 0,
  },
  title: {
    fontWeight: theme.other.fontWeights.semibold,
  },
  returnLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));

export default function HomepagePreviewBanner(): JSX.Element {
  const {classes} = useStyles();

  const {navShowHomepageUserOptOut} = useRolloutFlags();

  const handleReturnToLegacyHomepage = (): void => {
    trackHomepageEvent('opted_out', ACTION_CATEGORY.WRITE);
    SidepanelActions.collapse();
    preferences.set(HomepagePreferences.SHOW_NEW_HOMEPAGE, false);
  };

  return (
    <HomepageBanner
      color="yellow"
      leftSection={
        <Badge size="xl" radius="sm" className={classes.badge}>
          Beta
        </Badge>
      }
      rightSection={
        <Button
          // eslint-disable-next-line no-restricted-syntax -- no custom variant matches the design, yet
          variant="default"
          component="a"
          href="https://forms.gle/8kcjGfRn227coUBF7"
          leftIcon={<BenchlingIcon icon="message" />}
          rel="noopener noreferrer"
          size="md"
          target="_blank"
        >
          Share feedback
        </Button>
      }
    >
      <Box>
        <Text className={classes.title}>Welcome to your new homepage!</Text>
        {navShowHomepageUserOptOut && (
          <Text>
            You can still{' '}
            <Text
              span={true}
              className={classes.returnLink}
              {...getActionButtonRoleProps({onPress: handleReturnToLegacyHomepage})}
            >
              return to the legacy homepage
            </Text>{' '}
            for a limited time.
          </Text>
        )}
      </Box>
    </HomepageBanner>
  );
}
